import { useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  return (
    <header className="flex items-center justify-between px-6 py-4 bg-white border-b border-gray-200 shadow-sm">
      <div
        className="flex items-center gap-3 cursor-pointer"
        onClick={() => navigate("/home")}
      >
        <img
          src="/pta-logo.png"
          alt="PTA Logo"
          className="h-10 w-10 rounded-full"
        />
        <span className="text-xl font-semibold text-gray-800">
          PTA Training Resources
        </span>
      </div>
    </header>
  );
}

export default Header;
